import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "new-event-to-control" as const;

export type NewEventToControlEventData = {
  eventId: string;
};
export type NewEventToControlEvent = AppEvent<
  typeof eventName,
  NewEventToControlEventData
>;

export const isNewEventToControlEvent = (
  event: AnyAppEvent
): event is NewEventToControlEvent => event.name === eventName;

export { eventName as newEventToControl };
